import(/* webpackMode: "eager" */ "/home/runner/work/sms-service-frontend/sms-service-frontend/src/app/(static)/privacy-policy/page.tsx")